const getOrderAuthorization = ({ orderInsuranceParam, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (orderInsuranceParam && insurance) {
    const activeOrderInsuranceParam = orderInsuranceParam.find(item => item['Insurance ID'] === insurance.ID);
    return activeOrderInsuranceParam ? activeOrderInsuranceParam.Authorization : null;
  }
  return null;
};

export default getOrderAuthorization;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderAuthorization.js